module.exports = __webpack_public_path__ + "static/media/Cv_AnasZERHOUN.2e26c519.pdf";